<template>
  <div
    v-cloak
    v-if="notifications.length"
  >
    <transition name="fade-left" mode="out-in">
      <div
        class="notification-visible"
        v-if="show === 'true'"
        key="visible"
      >
        <button
          class="button is-transparent is-inline"
          title="Hide Notification"
          @click="hideNotification"
        >
          <span class="is-sr-only">Hide Notification</span><span class="delete is-medium"></span></button>
        <div v-for="notification in notifications" :key="notification.key" class="notification-content">
          <div v-html="notification.notification"></div>
        </div>
      </div>
      <div
        class="notification-hidden"
        key="false"
        v-else
      ><button
          class="button is-transparent is-inline"
          title="Show Notification"
          @click="showNotification"
        >
          <span class="is-sr-only">Show Notification</span><svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 330 330"
          >
            <path d="M165 0C74.019 0 0 74.02 0 165.001 0 255.982 74.019 330 165 330s165-74.018 165-164.999S255.981 0 165 0zm0 300c-74.44 0-135-60.56-135-134.999S90.56 30 165 30s135 60.562 135 135.001C300 239.44 239.439 300 165 300z" />
            <path d="M164.998 70c-11.026 0-19.996 8.976-19.996 20.009 0 11.023 8.97 19.991 19.996 19.991 11.026 0 19.996-8.968 19.996-19.991 0-11.033-8.97-20.009-19.996-20.009zM165 140c-8.284 0-15 6.716-15 15v90c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15v-90c0-8.284-6.716-15-15-15z" /></svg></button>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    notifications: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      show: null // string not boolean
    }
  },
  methods: {
    hideNotification () {
      this.show = 'false'
      localStorage[this.current] = 'false'
    },
    showNotification () {
      this.show = 'true'
      localStorage[this.current] = 'true'
    }
  },
  computed: {
    current () {
      return this.notifications.length ? this.notifications[0].key : null
    }
  },
  watch: {
    current () {
      if (localStorage[this.current]) {
        this.show = localStorage[this.current]
      } else if (this.current) {
        localStorage[this.current] = 'true'
        this.show = 'true'
      }
    }
  }
}
</script>
